// Home page component

import { CadastroFormPostal, initCadastroFormPostalEvents } from './CadastroFormPostal.js';

export async function HomePage() {

  const html = `



<div class="relative">
  <div class="hero min-h-[70vh] bg-cover bg-center bg-fixed relative" 
       style="background-image: linear-gradient(135deg, rgba(3, 128, 54, 0.85), rgba(0, 196, 94, 0.75)), url('/images/header.webp')">
    <div class="flex items-start justify-between w-full p-10">

      <div class="text-left">
        <h1 class="hero-title">¿Certificado<br> energético?</h1>
        <p class="hero-subtitlec flex-1 max-w-lg">¡Compara todos los asesores para conseguir<br>la mejor oferta!</p>

        <ul class="mt-4 space-y-2 text-white" role="list" aria-label="Hero voordelen">
          <li class="flex items-center gap-3">
            <span class="inline-flex items-center justify-center w-6 h-6 bg-green-500 rounded-full flex-shrink-0">
              <svg class="w-4 h-4 text-white" viewBox="0 0 20 20" fill="none">
                <path d="M5 10l3 3 7-7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="text-sm">Mejor precio y entrega más rápida garantizados</span>
          </li>

          <li class="flex items-center gap-3">
            <span class="inline-flex items-center justify-center w-6 h-6 bg-green-500 rounded-full flex-shrink-0">
              <svg class="w-4 h-4 text-white" viewBox="0 0 20 20" fill="none">
                <path d="M5 10l3 3 7-7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="text-sm">Compara asesores certificados cerca de ti</span>
          </li>

          <li class="flex items-center gap-3">
            <span class="inline-flex items-center justify-center w-6 h-6 bg-green-500 rounded-full flex-shrink-0">
              <svg class="w-4 h-4 text-white" viewBox="0 0 20 20" fill="none">
                <path d="M5 10l3 3 7-7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="text-sm">Comparación gratuita – pagas solo al recibir</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Formulier: overlay over hero background -->
<div class="w-full max-w-full md:max-w-lg mx-auto z-20 mt-8 md:absolute md:top-0 md:left-1/2 md:transform md:-translate-x-1/2">
  ${CadastroFormPostal({ formId: 'home-desktop' })}
</div>

<section class="section bg-white py-16 bg-[url('/images/bg-groendak.svg')] bg-no-repeat bg-top bg-cover">

  <div class="container pt-32">
    <h2 class="text-4xl text-blue-900 mb-29 text-center">¿Cómo funciona CEE Casas España?</h2>
      
    <!-- Four-step visual summary -->
    <div class="max-w-6xl mx-auto mt-8">
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 items-start">

        <!-- Vergelijk adviseurs -->
        <div class="text-center">
          <div class="relative w-20 h-16 mx-auto mb-4">
            <div class="absolute -rotate-6 bg-blue-200 w-20 h-12 rounded-xl top-0 left-1"></div>
            <img src="/images/icon/zoeken.webp" alt="Buscar" class="relative w-8 h-8 mx-auto" />
          </div>
          <h3 class="text-lg font-semibold text-gray-900 mb-2">Compara asesores</h3>
          <p class="text-gray-600">Compara de manera independiente todos los asesores certificados por precio, tiempo de entrega y valoración.</p>
        </div>

        <!-- Selecteer jouw adviseur -->
        <div class="text-center">
          <div class="relative w-20 h-16 mx-auto mb-4">
            <div class="absolute -rotate-6 bg-blue-200 w-20 h-12 rounded-xl top-0 left-1"></div>
            <img src="/images/icon/selecteer.webp" alt="Seleccionar" class="relative w-8 h-8 mx-auto" />
          </div>
          <h3 class="text-lg font-semibold text-gray-900 mb-2">Selecciona tu asesor</h3>
          <p class="text-gray-600">Pagas solo al recibir y tras el registro del certificado energético (y opcionalmente el informe de mejoras).</p>
        </div>

        <!-- Leun achterover -->
        <div class="text-center">
          <div class="relative w-20 h-16 mx-auto mb-4">
            <div class="absolute -rotate-6 bg-blue-200 w-20 h-12 rounded-xl top-0 left-1"></div>
            <img src="/images/icon/leun.webp" alt="Relájate" class="relative w-8 h-8 mx-auto" />
          </div>
          <h3 class="text-lg font-semibold text-gray-900 mb-2">Relájate</h3>
          <p class="text-gray-600">El asesor concierta una cita, visita tu vivienda y prepara el certificado energético (y el informe opcional).</p>
        </div>

        <!-- Ontvang -->
        <div class="text-center">
          <div class="relative w-20 h-16 mx-auto mb-4">
            <div class="absolute -rotate-6 bg-blue-200 w-20 h-12 rounded-xl top-0 left-1"></div>
            <img src="/images/icon/ontvang.webp" alt="Recibir" class="relative w-8 h-8 mx-auto" />
          </div>
          <h3 class="text-lg font-semibold text-gray-900 mb-2">Recibe</h3>
          <p class="text-gray-600">Recibirás tu certificado energético (y el informe opcional) por correo electrónico, ya registrado oficialmente.</p>
        </div>

      </div>
    </div>
  </div>
</section>



    <div class="grid md:grid-cols-3 gap-8">
      





      </div>

    </div>
  </div>
</section>


    


    
<!-- Nuestros valores fundamentales -->
<section class="section bg-blue-900 text-white">
  <div class="container max-w-6xl mx-auto py-16">
    <h2 class="text-3xl font-semibold text-center text-white mb-8">Nuestros <span class="italic text-3xl font-semibold text-center text-white mb-8">valores fundamentales</span></h2>
    <div class="grid grid-cols-1 md:grid-cols-4 gap-8 text-left text-sm">

      <div>
        <div class="mb-4 text-center">
          <img src="/images/icon/goedkoop.webp" alt="Económico" class="w-8 h-8 mx-auto" />
        </div>
        <h3 class="font-semibold text-white mb-2 text-center">Económico</h3>
        <p class="text-white/90">Compara de forma independiente todos los asesores certificados en tu zona por precio, tiempo de entrega y valoraciones. Aprovecha las mejores ofertas y precios competitivos.</p>
      </div>

      <div>
        <div class="mb-4 text-center">
          <img src="/images/icon/snel.webp" alt="Rápido" class="w-8 h-8 mx-auto" />
        </div>
        <h3 class="font-semibold text-white mb-2 text-center">Rápido</h3>
        <p class="text-white/90">Solicitar un certificado energético nunca ha sido tan fácil y rápido. En muchos casos recibirás tu certificado en un solo día hábil.</p>
      </div>

      <div>
        <div class="mb-4 text-center">
          <img src="/images/icon/betrouwbaar.webp" alt="Fiable" class="w-8 h-8 mx-auto" />
        </div>
        <h3 class="font-semibold text-white mb-2 text-center">Fiable</h3>
        <p class="text-white/90">Nuestro equipo cuenta con muchos años de experiencia en el sector energético y garantiza que todos los presupuestos, certificaciones y registros se realicen correctamente.</p>
      </div>

      <div>
        <div class="mb-4 text-center">
          <img src="/images/icon/klantgericht.webp" alt="Orientado al cliente" class="w-8 h-8 mx-auto" />
        </div>
        <h3 class="font-semibold text-white mb-2 text-center">Orientado al cliente</h3>
        <p class="text-white/90">Te mantenemos informado de las últimas novedades y estamos disponibles para todas tus dudas por teléfono, correo electrónico o WhatsApp.</p>
      </div>

    </div>
  </div>
</section>

<!-- Sobre los certificados energéticos -->
<section class="section bg-white py-16">
  <div class="container max-w-6xl mx-auto">
    <div class="grid grid-cols-1 md:grid-cols-2 items-center gap-8">

      <div class="relative flex justify-center md:justify-start">
        <div class="w-80 h-80 bg-green-300 transform -rotate-12 rounded-xl"></div>
        <img src="/images/team/about-energy-labels.webp" alt="pulgar arriba" class="absolute w-72 -rotate-6 -left-6 top-6" />
      </div>

      <div class="prose max-w-none">
        <h2 class="text-3xl font-bold text-green-700">Sobre <span class="italic text-3xl font-bold text-green-700">los certificados energéticos</span></h2>
        <p class="text-green-700">¿Por qué existe el certificado energético tal como lo conocemos? Todo tiene que ver con el calentamiento global. Por eso, el certificado energético es una obligación legal. La Tierra se está calentando debido a las emisiones de gases de efecto invernadero como el CO₂, que provienen en gran parte de nuestras viviendas. Para combatir esto, se ha introducido la normativa de certificados energéticos.</p>
        <p class="text-green-700">Así, el rendimiento energético de tu vivienda se muestra de manera clara. El objetivo del gobierno es informar a los propietarios sobre la eficiencia energética de su vivienda o local y motivarlos a tomar medidas de ahorro como el aislamiento o la instalación de paneles solares.</p>
        <a class="inline-block mt-4 bg-green-800 text-white py-2 px-4 rounded" href="/epc/">Más sobre certificados energéticos →</a>
      </div>

    </div>
  </div>
</section>

<!-- Sobre los informes de mejoras -->
<section class="section bg-green-50 py-16">
  <div class="container max-w-6xl mx-auto">
    <div class="grid grid-cols-1 md:grid-cols-2 items-center gap-8">

      <div class="prose max-w-none order-2 md:order-1">
        <h2 class="text-3xl font-bold text-green-700">Sobre <span class="italic text-3xl font-bold text-green-700">los informes de mejoras</span></h2>
        <p class="text-green-700">El informe de mejoras es, como su nombre indica, un asesoramiento personalizado para la eficiencia energética. Un asesor certificado identifica las medidas específicas que pueden mejorar el rendimiento energético de tu vivienda o local. Este tipo de informe es mucho más detallado que un simple "escaneo online".</p>
        <p class="text-green-700">Solo puede realizarlo un asesor EP autorizado y puede combinarse con un certificado energético. El certificado actúa como la medición inicial y el informe de mejoras te indica cómo mejorar desde ese punto.</p>
        <a class="inline-block mt-4 bg-green-600 text-white py-2 px-4 rounded" href="/improvements-report/">Más sobre informes de mejoras →</a>
      </div>

      <div class="relative flex justify-center md:justify-end order-1 md:order-2">
        <div class="w-80 h-48 bg-green-200 transform rotate-12 rounded-xl"></div>
        <img src="/images/team/about-custom-advise.webp" alt="asesor energético" class="w-72 -rotate-6 md:absolute md:right-0 md:top-3 relative mx-auto mt-4 md:mt-0" />
      </div>

    </div>
  </div>
</section>

<!-- CTA section -->
<section class="section bg-blue-600 text-white">
  <div class="container text-center">
    <h2 class="text-3xl font-bold mb-4">¿Listo para obtener tu certificado CEE?</h2>
    <p class="text-xl mb-8 opacity-90">Proceso transparente, precios fijos, técnicos certificados</p>
    <div class="flex flex-col sm:flex-row gap-4 justify-center">
      <button class="btn bg-white text-blue-600 hover:bg-gray-100" data-route="/cadastro/">Reservar certificado</button>
      <button class="btn border-white text-white hover:bg-white hover:text-blue-600" data-route="/contact/">Hacer una pregunta</button>
    </div>
  </div>
</section>

<!-- Sobre EPCSpainHomes -->
<section class="section bg-maroon-800 text-white py-16">
  <div class="container max-w-6xl mx-auto">
    <div class="grid grid-cols-1 md:grid-cols-2 items-center gap-8">

      <div class="relative flex justify-center md:justify-start">
        <div class="w-80 h-52 bg-white transform -rotate-12 rounded-xl"></div>
        <img src="/images/header1.webp" alt="edificio" class="absolute w-80 -rotate-6 left-0 top-6 rounded-xl" />
      </div>

      <div class="prose max-w-none">
        <h2 class="text-3xl font-bold">Somos <span class="italic text-3xl font-bold">CEEcasasespaña.com</span></h2>
        <p>CEEcasasespaña.com es una iniciativa de asesores con más de 20 años de experiencia en el mercado energético. Nuestro equipo está listo para ayudarte a obtener tu certificado energético (y opcionalmente un informe de mejoras) de manera fácil y rápida. Lo hacemos mostrando todos los asesores disponibles en tu zona y reuniendo toda la información en un solo lugar.</p>
        <p>Nos dedicamos a hacer fáciles las cosas difíciles. Por eso nuestros clientes nos evalúan con un promedio de 4,9 de 5 estrellas. ¡Estamos orgullosos de ello y nos motiva a seguir ofreciendo el mejor servicio!</p>
        <a class="inline-block mt-4 bg-white text-maroon-800 py-2 px-4 rounded" href="/about/">Más sobre nosotros →</a>
      </div>

    </div>
  </div>
</section>

<!-- FAQ -->
<section class="section bg-cream-100 py-16">
  <div class="container max-w-4xl mx-auto text-center">
    <h2 class="text-3xl font-semibold text-maroon-800 mb-8">
      Preguntas <span class="italic text-3xl font-semibold text-maroon-800 mb-8">frecuentes</span> sobre el certificado energético
    </h2>

    <div class="space-y-4 text-left" id="faq-accordion">

      <div class="accordion-item border border-maroon-700 rounded overflow-hidden">
        <button class="accordion-header flex justify-between items-center w-full bg-maroon-700 text-white p-4 text-left font-medium">
          <span>¿Qué es un certificado energético?</span>
          <span class="accordion-icon text-2xl font-bold">+</span>
        </button>
        <div class="accordion-panel hidden bg-maroon-50 text-maroon-900 p-4">
          <p>Un certificado energético muestra cuán eficiente es una vivienda o local. Indica el consumo de energía para calefacción, agua caliente, ventilación y refrigeración, con una escala de la A (muy eficiente) a la G (poco eficiente).</p>
        </div>
      </div>

      <div class="accordion-item border border-maroon-700 rounded overflow-hidden">
        <button class="accordion-header flex justify-between items-center w-full bg-maroon-700 text-white p-4 text-left font-medium">
          <span>¿Por qué solicitar un certificado en CEEcasasespaña.com?</span>
          <span class="accordion-icon text-2xl font-bold">+</span>
        </button>
        <div class="accordion-panel hidden bg-maroon-50 text-maroon-900 p-4">
          <p>En CEEcasasespaña.com puedes comparar de forma sencilla asesores EP certificados por precio, valoración y tiempo de entrega, para obtener un certificado rápido, económico y fiable.</p>
        </div>
      </div>

      <div class="accordion-item border border-maroon-700 rounded overflow-hidden">
        <button class="accordion-header flex justify-between items-center w-full bg-maroon-700 text-white p-4 text-left font-medium">
          <span>¿Por qué necesito un certificado energético?</span>
          <span class="accordion-icon text-2xl font-bold">+</span>
        </button>
        <div class="accordion-panel hidden bg-maroon-50 text-maroon-900 p-4">
          <p>Es obligatorio al vender, alquilar o entregar una vivienda o local. Informa a posibles compradores o inquilinos sobre la eficiencia energética del inmueble.</p>
        </div>
      </div>

      <div class="accordion-item border border-maroon-700 rounded overflow-hidden">
        <button class="accordion-header flex justify-between items-center w-full bg-maroon-700 text-white p-4 text-left font-medium">
          <span>¿Es obligatorio un certificado energético?</span>
          <span class="accordion-icon text-2xl font-bold">+</span>
        </button>
        <div class="accordion-panel hidden bg-maroon-50 text-maroon-900 p-4">
          <p>Sí, es obligatorio para la mayoría de viviendas y locales al vender, alquilar o entregar el inmueble. No tener uno puede resultar en multas.</p>
        </div>
      </div>

      <div class="accordion-item border border-maroon-700 rounded overflow-hidden">
        <button class="accordion-header flex justify-between items-center w-full bg-maroon-700 text-white p-4 text-left font-medium">
          <span>¿Para qué sirve un certificado energético?</span>
          <span class="accordion-icon text-2xl font-bold">+</span>
        </button>
        <div class="accordion-panel hidden bg-maroon-50 text-maroon-900 p-4">
          <p>Proporciona información sobre la eficiencia energética del inmueble y ofrece recomendaciones para mejorarla. Un mejor certificado puede aumentar el valor de la propiedad.</p>
        </div>
      </div>

      <div class="mt-8 text-center">
        <button onclick="location.href='/faq-customer/'" class="border border-maroon-700 text-maroon-700 py-2 px-6 rounded hover:bg-maroon-700 hover:text-white transition">Mostrar más preguntas</button>
      </div>

    </div>
  </div>
</section>


<!-- Accordion JS -->
<!-- Accordion JS is initialized by module-level code (no inline <script> tags) -->

<!-- Logos de asesores -->
<section class="section bg-white py-16">
  <div class="container max-w-6xl mx-auto text-center">
    <h2 class="text-3xl font-semibold text-center mb-6">Asesores en <span class="italic text-3xl font-semibold text-center mb-6">toda España</span> para elegir.</h2>

    <div class="p-8 rounded-lg shadow-sm bg-white">
      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
        ${Array.from({ length: 24 })
          .map((_, i) => {
            const idx = i + 1;
            const src =
              idx >= 1 && idx <= 24
                ? `/images/advisors/partner_logo_${idx}.webp`
                : '/images/advisors/partner_label.webp';
            return `
          <div class="flex items-center justify-center p-4 bg-white border rounded-md">
            <img src="${src}" alt="partner" class="max-h-16 object-contain opacity-90" />
          </div>
        `;
          })
          .join('')}
      </div>

      <div class="mt-8">
        <a href="/advisors/" class="inline-block border border-blue-900 text-blue-900 py-2 px-6 rounded hover:bg-blue-900 hover:text-white transition">
          Todos los asesores →
        </a>
      </div>
    </div>
  </div>
</section>


  `;

  // Na renderen: initialiseer het formulier (zorg dat het in de DOM staat)
  setTimeout(() => {
    try {
      initCadastroFormPostalEvents('home-desktop');
    } catch (e) {
      console.error('initCadastroFormPostalEvents faalde:', e);
    }
  }, 0);

  return html;
}
document.addEventListener("DOMContentLoaded", () => {
  const message = sessionStorage.getItem("homePopupMessage");

  if (message) {
    alert(message); // systeem popup
    sessionStorage.removeItem("homePopupMessage");
  }
});


// ===============================
// ✅ FAQ Accordion functionaliteit (delegated click listener)
// ===============================
if (typeof window !== "undefined" && !window.__faqAccordionActive) {
  window.__faqAccordionActive = true;

  document.addEventListener("click", (e) => {
    const header = e.target.closest(".accordion-header");
    if (!header) return;

    const item = header.closest(".accordion-item");
    const panel = item?.querySelector(".accordion-panel");
    const icon = header.querySelector(".accordion-icon");
    if (!item || !panel || !icon) return;

    const isOpen = header.getAttribute("aria-expanded") === "true";

    // Sluit andere items in dezelfde container
    const container = item.parentElement;
    container.querySelectorAll(".accordion-item").forEach((it) => {
      const h = it.querySelector(".accordion-header");
      const p = it.querySelector(".accordion-panel");
      const i = it.querySelector(".accordion-icon");
      if (!h || !p || !i) return;
      h.setAttribute("aria-expanded", "false");
      p.classList.add("hidden");
      i.textContent = "+";
    });

    // Toggle huidige item
    if (!isOpen) {
      header.setAttribute("aria-expanded", "true");
      panel.classList.remove("hidden");
      icon.textContent = "−"; // echt minteken
    } else {
      header.setAttribute("aria-expanded", "false");
      panel.classList.add("hidden");
      icon.textContent = "+";
    }
  });
}
